import React from 'react'

function ResetPassword() {
  return (
    <>
      {/* strat content */}
      <div className="flex flex-row justify-center items-center bg-gray-100 md:mt-16 p-6 w-full h-screen">

        <div className="space-y-8 bg-white px-4 py-6 rounded-md w-full max-w-sm">
          <h1 className="font-semibold text-center text-xl">Réinitialiser le mot de passe</h1>
          <p className="font-medium text-center text-gray-500 text-sm">
            Vous n'êtes qu'à un pas de votre nouveau mot de passe,
            récupérez votre mot de passe maintenant.
          </p>
          <form action="#" className="space-y-6">
            <input
              className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
              type="email"
              name="email"
              placeholder="Votre email"
              required
            />
            <input
              className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
              type="password"
              name="password"
              placeholder="Mot de passe"
              required
            />
            <input
              className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
              type="password"
              name="passwordConfirm"
              placeholder="Confirmer le mot de passe"
              required
            />
            <div>
              <button
                type="submit"
                className="bg-teal-600 px-4 py-2 rounded-md focus:ring-2 focus:ring-primary focus:ring-offset-1 dark:focus:ring-offset-darker w-full font-medium text-center text-white transition-colors duration-200 focus:outline-none"
              >
                Réinitialiser le mot de passe
              </button>
            </div>
          </form>

          <div className="flex flex-nowrap justify-center items-center space-x-2">
            <span className="bg-gray-300 w-20 h-px"></span>
            <span>OU</span>
            <span className="bg-gray-300 w-20 h-px"></span>
          </div>

          <div className="text-center text-gray-600 text-sm dark:text-gray-400">
            souvenez-vous de votre mot de passe ?<a href="/login" className="text-teal-500 hover:underline"> se connecter </a>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  )
}

export default ResetPassword